// typography.ts
import fonts from "./fonts";

const typography = {
  fontFamily: fonts.primary,
  h1: {
    fontFamily: fonts.secondary,
    fontSize: "4rem",
    fontWeight: 300,
    lineHeight: 1.125,
  },
  h2: {
    fontFamily: fonts.secondary,
    fontSize: "3rem",
    fontWeight: 300,
    lineHeight: 1.167,
  },
  h3: {
    fontFamily: fonts.secondary,
    fontSize: "2.25rem",
    fontWeight: 300,
    lineHeight: 1.222,
  },
  h4: {
    fontFamily: fonts.secondary,
    fontSize: "1.875rem",
    fontWeight: 300,
    lineHeight: 1.2,
  },
  h5: {
    fontFamily: fonts.secondary,
    fontSize: "1.5rem",
    fontWeight: 300,
    lineHeight: 1.333,
  },
  h6: {
    fontFamily: fonts.secondary,
    fontSize: "1.25rem",
    fontWeight: 300,
    lineHeight: 1.333,
  },
  body1: {
    fontFamily: fonts.primary,
    fontSize: "1rem",
    fontWeight: 400,
    lineHeight: 1.5,
  },
  body2: {
    fontFamily: fonts.primary,
    fontSize: "0.875rem",
    fontWeight: 400,
    lineHeight: 1.429,
  },
  body3: {
    fontFamily: fonts.primary,
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: 1,
  },
  button: {
    fontFamily: fonts.primary,
    fontSize: "1rem",
    fontWeight: 500,
    textTransform: "uppercase" as "uppercase", // Explicitly casting to correct type
  },
  overline: {
    fontFamily: fonts.primary,
    fontSize: "0.75rem",
    fontWeight: 500,
    textTransform: "uppercase" as "uppercase", // Explicitly casting to correct type
  },
};

export default typography;
